<template>
  <md-toolbar md-elevation="0">
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h1 class="md-title">{{ $route.name }}</h1>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <md-list-item @click="$router.push('/dashboard')">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item>
            <md-list-item @click="$router.push('/cart')">
              <i class="material-icons">shopping_cart</i>
              <span class="notification notification-cart">{{ cartSize }}</span>
              <p class="hidden-lg hidden-md">Cart</p>
            </md-list-item>
            <md-list-item @click="$router.push('/account')">
              <i class="material-icons">person</i>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    cartSize() {
      return this.$store.getters.cartSize;
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    }
  }
};
</script>

<style lang="scss"></style>
